import request from "@/utils/request";
// 活动页配置相关接口

// 活动页列表
export function getActivityPageList({
  createBy,
  pageSize,
  productId,
  pageIndex,
  productName,
  activityName,
  productIdList,
  activityStatus,
  columnId
}) {
  return request({
    url: "/newMall/h5Activity/getH5ActivityList",
    method: "GET",
    data: {
      createBy,
      pageSize,
      productId,
      pageIndex,
      productName,
      activityName,
      productIdList,
      activityStatus,
      columnId
    }
  });
}

// 活动页详情
export function getActivityPageInfo(activityId) {
  return request({
    url: "/newMall/h5Activity/getH5Activity",
    method: "GET",
    data: {
      activityId
    }
  });
}

// 新增活动页
export function addActivityPageItem({
  draftContent,
  activityName,
  productIdList,
  collocationIdList,
  columnId
}) {
  return request({
    url: "/newMall/h5Activity/createH5Activity",
    method: "POST",
    data: {
      draftContent,
      activityName,
      productIdList,
      collocationIdList,
      columnId
    }
  });
}

// 更新活动页
export function updateActivityPageItem({
  createBy,
  activityId,
  draftContent,
  activityName,
  productIdList,
  collocationIdList,
  columnId
}) {
  return request({
    url: "/newMall/h5Activity/updateH5Activity",
    method: "POST",
    data: {
      createBy,
      activityId,
      draftContent,
      activityName,
      productIdList,
      collocationIdList,
      columnId
    }
  });
}

// 发布活动页
export function releaseActivityPageItem({
  activityId,
  activityName,
  draftContent,
  productIdList,
  scheduleTime,
  releaseType,
  collocationIdList,
  columnId
}) {
  return request({
    url: "/newMall/h5Activity/onlineH5Activity",
    method: "POST",
    data: {
      activityId,
      activityName,
      draftContent,
      productIdList,
      scheduleTime,
      releaseType,
      collocationIdList,
      columnId
    }
  });
}

// 下线活动页
export function offlineActivityPageItem(activityId) {
  return request({
    url: "/newMall/h5Activity/offlineH5Activity",
    method: "POST",
    data: {
      activityId
    }
  });
}

// 取消定时发布
export function cancelScheduleReleaseActivity(activityId) {
  return request({
    url: "/newMall/h5Activity/cancelScheduledH5Activity",
    method: "POST",
    data: {
      activityId
    }
  });
}

// 查询活动页商品列表
export function getSpreadActivityProductList(productIdList) {
  return request({
    url: "/newMall/h5Activity/getH5ActivityProductList",
    method: "POST",
    data: {
      productIdList
    }
  });
}

// 查询活动页优惠券列表
export function getSpreadActivityCouponList(couponIdList) {
  return request({
    url: "/newMall/h5Activity/getH5ActivityCouponList",
    method: "POST",
    data: {
      couponIdList
    }
  });
}

// 查询活动页搭销列表
export function getSpreadActivityCollocationList(collocationIdList) {
  return request({
    url: "/newMall/h5Activity/getH5ActivityCollocationList",
    method: "POST",
    data: {
      collocationIdList
    }
  });
}

// 查询活动页文章列表
export function getSpreadActivityArticleList(articleIdList) {
  return request({
    url: "/newMall/h5Activity/getH5ActivityArticleList",
    method: "POST",
    data: {
      articleIdList
    }
  });
}

// 保存预览信息
export function savePreviewActivity(draftContent) {
  return request({
    url: "/newMall/h5Activity/createPreviewH5Activity",
    method: "POST",
    data: {
      draftContent
    }
  });
}

// 查询所有门店列表
export function getStoreList() {
  return request({
    url: "/newMall/store/getStoreList",
    method: "get",
    params: {
      pageIndex: 1,
      pageSize: 9999
    }
  });
}

// 查询所有抽奖活动列表
export function getPrizeDrawActivitys(params) {
  return request({
    url: "/newMall/lotteryActivity/getH5LotteryActivityList",
    method: "get",
    params
  });
}

// 查询抽奖活动详情
export function getH5LotteryActivity(params) {
  return request({
    url: "/newMall/lotteryActivity/getH5LotteryActivity",
    method: "get",
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/shop/activitySet.js